import React from 'react';
import { useIntl } from 'react-intl';

import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';

import { Chip, Typography } from 'components/v2';

import useProceduresSearch, { ProceduresStatus } from './hooks/useProceduresSearch';

import { useFiltersContext } from '../context/FixedFiltersContext';
import FiltersListWrapper from '../FiltersListWrapper';
import FiltersContentLoader from '../FiltersContentLoader';
import messages from './messages';

interface FilterProceduresListProps {
  searchTerm: string;
  type: string;
}
const FilterProceduresList: React.FC<FilterProceduresListProps> = ({ searchTerm, type }) => {
  const { filters, updater } = useFiltersContext();
  const { formatMessage } = useIntl();
  const procedures = useProceduresSearch({ searchTerm });

  const cptCodeFilter = filters[type] || [];
  const updateIcdCodeFilter = updater(type);

  const isSelected = (item: string) => cptCodeFilter.includes(item);

  return (
    <FiltersListWrapper>
      {!searchTerm && (
        <Typography variant="secondarySectionHeader" gutterBottom>
          {formatMessage(isEmpty(cptCodeFilter) ? messages.filteringForEmpty : messages.filteringFor)}
        </Typography>
      )}
      <Grid container spacing={8}>
        {procedures.status === ProceduresStatus.Loading && <FiltersContentLoader chipCount={12} />}
        {(searchTerm ? procedures.data : cptCodeFilter).map((item: any) => (
          <Grid item key={item}>
            <Chip
              color="supportPowder"
              label={item}
              selected={isSelected(item)}
              onClick={() => updateIcdCodeFilter(item)}
            />
          </Grid>
        ))}
        {procedures.status === ProceduresStatus.NoData && (
          <Typography variant="supportBook">{formatMessage(messages.noResults)}</Typography>
        )}
      </Grid>
    </FiltersListWrapper>
  );
};

export default FilterProceduresList;
